import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';

export class DeliverooApiService extends ApiService<any> {
  constructor() {
    super('deliveroo', 'v1');
  }

  public syncFoodcard(payload: { venue: string }): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/menus/venues/${payload.venue}`);
  }
}
